/**
 *
 * ChangeLanguage
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 13-Jan-2023
 */

import React, { useState, useContext } from 'react';
import PortalModal from 'Components/PortalModal/PortalModal';
import { LanguageContext } from 'Containers/MainContainer';
import PortalSelect from 'Components/PortalSelect/PortalSelect';
import formattedMessages from '../../modules/languageModule';
import PropTypes from 'prop-types';
import style from './ChangeLanguage.scss';
import { Grid } from '@mui/material';

const ChangeLanguage = (props) => {
  const languageContext = useContext(LanguageContext);
  const [lang, setLang] = useState(languageContext.language);

  const saveButtonOnClickHandler = () => {
    languageContext.changeLanguage(lang);
    props.actions.closeModal();
  };

  return (
    <PortalModal
      className={style.container}
      title={formattedMessages.changeLanguage}
      actions={{ handleClose: () => {} }}
      buttons={[
        {
          variant: 'outlined',
          onClick: props.actions.closeModal,
          contentText: formattedMessages.abortLabelButton,
        },
        {
          variant: 'contained',
          onClick: () => saveButtonOnClickHandler(),
          contentText: formattedMessages.confirmLabelButton,
          isLoading: props.isLoading,
        },
      ]}>
      <PortalSelect
        id='changeLanguage'
        label={formattedMessages.language}
        menuItems={[
          { value: 'it', content: formattedMessages.italian },
          { value: 'en', content: formattedMessages.english },
        ]}
        value={lang}
        onChange={(e) => setLang(e.target.value)}
      />
    </PortalModal>
  );
};

ChangeLanguage.propTypes = {
  actions: PropTypes.objectOf(PropTypes.func),
  isLoading: PropTypes.bool,
};

ChangeLanguage.defaultProps = {
  // Add here some default propTypes values
};
export default ChangeLanguage;
